import { render } from "./TagFilterBar.vue?vue&type=template&id=18c8a0d0&scoped=true"
import script from "./TagFilterBar.vue?vue&type=script&lang=js"
export * from "./TagFilterBar.vue?vue&type=script&lang=js"

import "./TagFilterBar.vue?vue&type=style&index=0&id=18c8a0d0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18c8a0d0"]])

export default __exports__